"use client"
import Icon from '@ant-design/icons';
import type { GetProps } from 'antd';

type CustomIconComponentProps = GetProps<typeof Icon>;

const DestinationSvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.633 3.58016C13.6733 3.47898 13.6882 3.36946 13.6764 3.26118C13.6646 3.15291 13.6264 3.04918 13.5652 2.95906C13.5041 2.86895 13.4217 2.79519 13.3255 2.74425C13.2292 2.69331 13.1219 2.66672 13.013 2.66683H4.66634V2.00016C4.66634 1.6335 4.36634 1.3335 3.99967 1.3335C3.63301 1.3335 3.33301 1.6335 3.33301 2.00016V14.6668H4.66634V9.3335H13.013C13.4863 9.3335 13.8063 8.86016 13.633 8.42016L12.6663 6.00016L13.633 3.58016ZM9.99967 6.00016C9.99967 6.7335 9.39967 7.3335 8.66634 7.3335C7.93301 7.3335 7.33301 6.7335 7.33301 6.00016C7.33301 5.26683 7.93301 4.66683 8.66634 4.66683C9.39967 4.66683 9.99967 5.26683 9.99967 6.00016Z" fill="currentColor" />
  </svg>

)

const DestinationIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={DestinationSvg} {...props} />
);

export default DestinationIcon